module.exports = __webpack_public_path__ + "static/RootSans-2ThinItalic-ac2a04ea813fd04c3b03e74cf5cfe026.woff";